// This file (and its related code) was extracted from `src/rxdb/syncReplicationStatesWithGraphQL.ts`
import { LiveInterval } from '@/rxdb/constants';

import {
  BorerOperatorChange,
  borerOperatorChangePushQueryBuilder,
} from '../../BorerOperatorChangeFeed/queryBuilder';
import { create } from '../FamilyMember/create';
import { FamilyMember } from '../FamilyMember/FamilyMember';
import { ConfigBuilder, push, replicate, ReplicationState, schedule } from '../replicate';
import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { pushModifier } from './pushModifier';
import { pushResponseModifier } from './pushResponseModifier';

export function createReplicationState(
  configBuilder: ConfigBuilder,
): ReplicationState<BorerOperatorChange> {
  const syncConfig = configBuilder<BorerOperatorChange>(
    RxdbCollectionNameV2.BORER_OPERATOR_CHANGE_FEED,
  );

  // Note that BORER_OPERATOR_CHANGE_FEED does *not* have a pull query.

  const pushConfig = push(syncConfig, borerOperatorChangePushQueryBuilder);
  pushConfig.responseModifier = pushResponseModifier;
  pushConfig.modifier = pushModifier;

  const replicationState = replicate(syncConfig);
  return replicationState;
}

export function replicateBorerOperatorChange(
  configBuilder: ConfigBuilder,
  syncStates: ReplicationState<unknown>[],
  reSyncTimeouts: NodeJS.Timeout[],
): ReplicationState<BorerOperatorChange> {
  const replicationState = createReplicationState(configBuilder);
  syncStates.push(replicationState as ReplicationState<unknown>);

  const reSyncInterval = schedule(replicationState, LiveInterval.SECONDS_60);
  reSyncTimeouts.push(reSyncInterval);

  return replicationState;
}

export function borerOperatorChangeFeedFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember,
  borerShiftAdvance: FamilyMember,
  borerStateType: FamilyMember,
  cuttingMethod: FamilyMember,
  cuttingType: FamilyMember,
  equipment: FamilyMember,
): FamilyMember<BorerOperatorChange> {
  const replicationState = createReplicationState(configBuilder);

  return create(RxdbCollectionNameV2.BORER_OPERATOR_CHANGE_FEED, replicationState, [
    borerShift,
    borerShiftAdvance,
    borerStateType,
    cuttingMethod,
    cuttingType,
    equipment,
  ]);
}
